<template>
    <div v-if="message" :id="id" class="invalid-feedback d-flex align-items-start gap-1">
        <!-- One message, directly under its control. Renders nothing when there is no error, so
             an untouched field reserves no space and the layout doesn't jump when an error
             clears. d-flex forces .invalid-feedback visible: Bootstrap only shows it next to an
             .is-invalid sibling, and the control is often wrapped inside a child component. -->
        <svg class="flex-shrink-0 mt-1" width="12" height="12" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7.1 4.4a.9.9 0 1 1 1.8 0l-.35 4.9a.55.55 0 0 1-1.1 0L7.1 4.4zM8 10.6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg>
        <span>{{ getTranslatedText(message, 'validations') }}</span>
    </div>
</template>

<script setup>

import { inject, computed } from 'vue';

const props = defineProps({
    errors: {
        type: Array,
        required: false,
        default: () => []
    },
    id: {
        type: String,
        required: false,
        default: undefined
    },
});

const { getTranslatedText } = inject('app');

const message = computed(() => (Array.isArray(props.errors) && props.errors.length > 0) ? props.errors[0] : null);

</script>
